import React, { useEffect, useState } from 'react';

const injectFont = () => {
  if (document.getElementById('text-security-font')) return;
  const style = document.createElement('style');
  style.id = 'text-security-font';
  style.innerHTML = `
    @font-face {
      font-family: text-security-disc;
      src: url("/public/text-security-disc.woff") format("woff");
    }
  `;
  document.head.appendChild(style);
};

function MaskedTextInput({
  className = '',
  style = {},
  show: showProp,
  onToggle,
  ...props
}) {
  const [internalShow, setInternalShow] = useState(false);

  const supportsWebkitTextSecurity = () => {
    return 'webkitTextSecurity' in document.body.style;
  }


  // Use prop if provided, fallback to internal state
  const isControlled = showProp !== undefined;
  const show = isControlled ? showProp : internalShow;

  useEffect(() => {
    if (!supportsWebkitTextSecurity())
        injectFont();
  }, []);

  const inputStyle = show ? style
  : supportsWebkitTextSecurity()
    ? {
        ...style,
        WebkitTextSecurity: 'disc',
      }
    : {
        ...style,
        fontFamily: 'text-security-disc',
        fontSize: '1rem',
        letterSpacing: '1px',
      };

  const handleToggle = () => {
    if (isControlled) {
      onToggle?.(!showProp);
    } else {
      setInternalShow((prev) => !prev);
    }
  };

  return (
      <input
        type="text"
        autoComplete="off"
        className={className}
        style={inputStyle}
        {...props}
        placeholder={supportsWebkitTextSecurity() ? props.placeholder : ''}
      />
  );
}

export default MaskedTextInput;